import { z } from "zod";
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).default(50),
});
export function pagedResponse(item) {
    return z.object({
        items: z.array(item),
        page: z.number().int(),
        pageSize: z.number().int(),
        total: z.number().int(),
    });
}
//# sourceMappingURL=pagination.js.map